import { useFocusEffect } from '@react-navigation/native';
import { useCallback, useEffect, useRef, useState } from 'react';
import { isWeb } from '@helpers';
import { MODE } from '@v2/pages/machines/common/enums';
import { fullWidth } from '@components/frame';
import { NARROW_WEB_BREAKPOINT } from '@v2/pages/common/constants/base.constants';

export const useChangeDisplayModeOnResize = () => {
  const getCurrentMode = () => ((isWeb ? window?.innerWidth : fullWidth) <= NARROW_WEB_BREAKPOINT ? MODE.DETAILS : MODE.FULL);

  const [mode, setMode] = useState<MODE>(getCurrentMode);

  const modeRef = useRef(mode);
  modeRef.current = mode;

  useFocusEffect(
    useCallback(() => {
      if (!isWeb) return;

      const listener = () => {
        const newMode = getCurrentMode();

        if (modeRef.current !== newMode) {
          setMode(newMode);
        }
      };

      listener();

      window.addEventListener('resize', listener);
      return () => window.removeEventListener('resize', listener);
    }, [])
  );

  return { mode };
};
